export default function StatsSection() {
  const stats = [
    { number: '500,000+', label: '累计服务用户', icon: 'ri-user-line' },
    { number: '10,000+', label: '收录优质网站', icon: 'ri-links-line' },
    { number: '8', label: '核心分类覆盖', icon: 'ri-grid-line' },
    { number: '99.9%', label: '服务可用率', icon: 'ri-shield-check-line' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
            值得信赖的数据表现
          </h2>
          <p className="text-primary-200 text-sm md:text-base">
            用数据说话，我们持续为数十万用户提供稳定的导航服务
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-background-50/15 rounded-lg">
                <i className={`${stat.icon} text-xl text-background-50`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-background-50 font-heading mb-1">
                {stat.number}
              </div>
              <div className="text-sm text-primary-200 whitespace-nowrap">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}